/* StarringYou — histoire sauvegardée sur l'appareil (localStorage, 14 jours), reprise sans email. */
(function () {
  var KEY = 'sy_story', MAX = 14 * 864e5;
  function saved() {
    try { var s = JSON.parse(localStorage.getItem(KEY) || 'null'); if (s && s.name && s.step >= 2 && Date.now() - s.ts < MAX) return s; } catch (e) {}
    return null;
  }
  function clear() { try { localStorage.removeItem(KEY); } catch (e) {} }
  function show(s, onGo, onNew) {
    var m = document.getElementById('syResume'); if (!m) return onGo();
    var name = String(s.name || '').replace(/["'’`]+/g, '').trim();
    name = name.charAt(0).toUpperCase() + name.slice(1);
    document.getElementById('syResumeT').textContent = 'Continue ' + name + '’s story?';
    var img = document.getElementById('syResumeImg');
    var src = (s.pv && s.pv.url) || s.photo || '';
    img.hidden = !src; if (src) img.src = src;
    m.hidden = false; document.body.style.overflow = 'hidden';
    var close = function () { m.hidden = true; document.body.style.overflow = ''; };
    document.getElementById('syResumeGo').onclick = function () { close(); try { SYTrack.event('sy_resume_continue', {}); } catch (e) {} onGo(); };
    document.getElementById('syResumeNew').onclick = function () { close(); clear(); try { SYTrack.event('sy_resume_new', {}); } catch (e) {} onNew(); };
  }
  window.SYResume = { key: KEY, saved: saved, clear: clear, show: show };
  /* Accueil : les boutons qui mènent au tunnel proposent d'abord de reprendre */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-sy-start]');
    if (!a || document.body.classList.contains('sy--funnel')) return;
    var s = saved(); if (!s || e.defaultPrevented) return;
    e.preventDefault();
    var href = a.getAttribute('href');
    show(s, function () { location.href = href + (href.indexOf('?') > -1 ? '&' : '?') + 'resume=1'; }, function () { location.href = href; });
  });
})();
